import * as React from 'react'
import { ParticipantFormFields, RoomWithParticipants } from '@/scopes/checkout/domain/types/checkoutPersonalDetails'
import { ParticipantFormType } from '@/scopes/checkout/domain/types/participantFormType'

export function useParticipantIndices(participantsByRooms: RoomWithParticipants[] | undefined | null) {
  return React.useMemo(() => {
    const indices = new Map<number, number>()
    const typeCounters = new Map<ParticipantFormType, number>()

    if (!participantsByRooms)
      return indices

    participantsByRooms?.forEach((room: RoomWithParticipants) => {
      room.participants.forEach((participant: ParticipantFormFields) => {
        const { type } = participant
        const isMainBooker = type === ParticipantFormType.MainBooker
        const normalizedType = isMainBooker ? ParticipantFormType.Adult : type

        const currentCount = typeCounters.get(normalizedType) || 0
        const nextCount = currentCount + 1

        typeCounters.set(normalizedType, nextCount)
        indices.set(participant.id, nextCount)
      })
    })

    return indices
  }, [participantsByRooms])
}
